import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "header"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "content"
};
const _hoisted_4 = { class: "mt-5 mb-5" };
const _hoisted_5 = { class: "actioned" };
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GuideTaskPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getPlanTask, setPlanTaskCompleted } = useContent();
        function onLoad() {
            getCustomer();
            getPlanTask(route.params.id);
        }
        function action() {
            if (state.planTask.actionUrl && state.planTask.actionUrl != '') {
                window.location.href = state.planTask.actionUrl;
            }
            else {
                router.back();
            }
        }
        function setCompleted() {
            setPlanTaskCompleted(state.planTask.id, state.planTask.completed);
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).planTask
                }, null, 8, ["customer"]),
                (_unref(state).planTask)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("img", {
                            src: _unref(state).planTask.icon ?? require('@/assets/round1.png')
                        }, null, 8, _hoisted_2)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).planTask)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("h1", null, _toDisplayString(_unref(state).planTask.title), 1),
                                _createElementVNode("h2", null, _toDisplayString(_unref(state).planTask.tagLine), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(state).planTask.description), 1),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode(_component_v_checkbox, {
                                            class: "completedCheck",
                                            onChange: setCompleted,
                                            modelValue: _unref(state).planTask.completed,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(state).planTask.completed) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createElementVNode("h2", null, _toDisplayString(_unref(state).planTask.completedTitle), 1),
                                        _createElementVNode("p", null, _toDisplayString(_unref(state).planTask.completedDescription), 1)
                                    ]),
                                    _createVNode(MGButton, {
                                        text: _unref(state).planTask.actionTitle,
                                        fullWidth: "",
                                        onClick: action
                                    }, null, 8, ["text"])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
